import React from "react";
import {Collapse} from 'antd';

const {Panel} = Collapse;

const QA = [
    // {
    //     "question": "Can I bring a guest?",
    //     "answer": <div className="answer"><div>Yes. Every winner may bring 1 guest so long as the guest is above the age of 21 and not a former or current employee of Forter.</div></div>
    // },
    // {
    //     "question": "Can I bring other guests that I pay for?",
    //     "answer": <div className="answer"><div>No. Our rooms are only for 2 adults maximum. Additional guests (including children), regardless of cost or who pays, are prohibited.</div></div>
    // },
    // {
    //     "question": "What if I’m invited and cannot attend?",
    //     "answer": <div className="answer"><div>Please be sure to RSVP “No”. There is no alternative prize, but SWAG will be mailed after the event to those who can’t attend.</div></div>
    // },
    {
        "question": "Should I put in PTO for the Excellence Club?",
        "answer": <div className="answer"><div>No, that’s not needed. Your manager has been notified of your RSVP.</div></div>
    },
    // {
    //     "question": "Am I allowed to travel from another location besides my allotted home office?",
    //     "answer": <div className="answer"><div>You would need to verify that the cost of your roundtrip ticket from your home city would be comparable to (or less than) your proposed deviation.For example, if you are based in Paris but want to come from California, the cost of your flight from California/Rome/Paris needs to be equal to or less than a roundtrip flight from Paris/Rome/Paris. If it’s not, you will be responsible for your arrival to Excellence Club and Forter would only cover the return flight home. It is not permitted to charge the more expensive flights to Forter and attempt to repay the company.</div></div>
    // },
    {
        "question": "Can I come earlier and/or stay longer?",
        "answer": <div className="answer"><div>Sure! However, you must note 1) All hotel nights outside of the event are at your own expense. 2) Forter will not reimburse expenses accrued before or after the Excellence Club dates.</div></div>
    },
    // {
    //     "question": "I want to explore other cities before or after the Excellence Club. May I?",
    //     "answer": <div className="answer"><div>Forter will cover 1 round-trip flight. If you are seeking to stop somewhere before or after Rome, the flights will become your own expense. You may not use the invitation to book multiple stops for other cities.</div></div>
    // },
    {
      "question": "Meals Covered by Forter",
      "answer": <div className="answer"><div>
          <ul>
              <li>Monday: Lunch & Dinner</li>
              <li>Tuesday & Wednesday: Breakfast, Lunch, and Dinner</li>
              <li>Thursday: Breakfast</li>
          </ul>
      </div></div>
    },
    {
        "question": "What’s Eligible for Reimbursement?",
        "answer": <div className="answer"><div>
            <ul>
                <li>Taxi rides between your home and the airport (both arrival and departure) unless group transportation is arranged</li>
                <li>Taxi rides between the airport and the hotel (both arrival and departure) unless group transportation is arranged</li>
                <li>Meals on travel days (Sunday/Monday and Thursday), in line with Forter’s standard expense policy</li>
            </ul>

        </div></div>
    },
    {
        "question": "What is included while we are in Barcelona?",
        "answer": <div className="answer">    <div>Forter will take care of hotel accommodations, flights, and all planned group activities for you and your guest. You’ll have free time to explore on your own, and any personal activities during that time will be at your own expense.</div></div>
    },
    {
        "question": "What is the Agenda?",
        "answer": <div className="answer">    <div>You can find the entire schedule by navigating to the 'Agenda' tab.</div></div>
    },
    {
        "question": "Is there a dress code?",
        "answer": <div className="answer">    <div>If a dress code is required for a particular event or occasion, we will include it in the agenda.</div></div>
    },
    {
        "question": "I have other questions about travel and policy.",
        "answer": <div className="answer">    <div>Please reach out to excellenceclub@forter.com</div></div>
    },
    {
        "question": "Arrivals and Event Check-In",
        "answer": <div className="answer">    <div>To get to the hotel from the airport, you must order a local taxi and keep the receipt for reimbursement. Hotel check-in is at 3:00 PM and we will do our best to accommodate early check-ins based on availability.</div></div>
    },
    {
        "question": "Departures & Hotel Checkout",
        "answer": <div className="answer">    <div>Hotel checkout is at noon and we will do our best to accommodate late checkouts as needed. You will be able to continue to use the hotel facilities and store your baggage if your departure time is after checkout.</div></div>
    },
    {
        "question": "Are there mandatory Activities?",
        "answer": <div className="answer">    <div>All the optional and mandatory events have been listed in the agenda.</div></div>
    },
    {
        "question": "Will Forter reimburse me for a communication / Wi-Fi package?",
        "answer": <div className="answer">    <div>No. Wi-Fi will be available in the hotel. If there are any specific work-related requirements for a communication package, please contact excellenceclub@forter.com.</div></div>
    },
    {
        "question": "What is the weather like in Barcelona?",
        "answer": <div className="answer">    <div>In June, Barcelona enjoys warm and sunny weather with average highs ranging from 24 to 29 degrees Celsius (75 to 84 degrees Fahrenheit). It’s a great time to explore the city, but it’s advisable to wear light clothing, apply sunscreen, and stay hydrated during this lively early summer month.</div></div>
    }
]

class Faq extends React.Component {
    render() {
        return <div id="faq">
            <h1>FAQ</h1>
            <div className="content">
                <Collapse className="faq-wrapper">
                    {QA.map((qa, index) => {
                            return <Panel header={qa.question} key={index}>
                                {qa.answer}
                            </Panel>
                        }
                    )}
                </Collapse>
            </div>
        </div>;
    }
}

export default Faq;
